import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  const before = ['Horas planificando cada clase', 'Actividades repetitivas y aburridas', 'Sin un plan de evaluación claro', 'Currícula desactualizada', 'Alumnos desmotivados'];
  const after = ['5 minutos de repaso antes de entrar', 'Clases dinámicas y variadas', 'Rúbricas y evaluaciones listas', 'Contenidos modernos y progresivos', 'Alumnos participativos'];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-162">
      <div className="max-w-5xl mx-auto" data-id="element-163">
        <div className="flex flex-col md:flex-row gap-12 items-center mb-16" data-id="element-164">
          <div className="flex-1" data-id="element-165">
            <h2 className="text-4xl md:text-5xl font-black text-brand-text leading-[1.1] tracking-tight mb-6 text-balance" data-id="element-166">
              De un docente sobrecargado a un{' '}
              <span className="italic text-brand-red" data-id="element-167">guía inspirado.</span>
            </h2>
            <div className="flex items-center gap-4 bg-white/60 p-4 rounded-2xl inline-flex border border-brand-creamDark/50" data-id="element-168">
              <span className="text-4xl font-serif font-bold text-brand-gold" data-id="element-169">
                3.500+
              </span>
              <span className="text-sm text-brand-gray font-medium max-w-[150px] leading-tight" data-id="element-170">
                horas ahorradas al año en planificación.
              </span>
            </div>
          </div>

          <div className="flex-1 w-full bg-white rounded-3xl shadow-sm border border-brand-creamDark grid grid-cols-1 sm:grid-cols-2 overflow-hidden" data-id="element-171">
            {/* ANTES */}
            <div className="bg-[#faf6f1] p-6 md:p-8" data-id="element-172">
              <div className="flex items-center gap-2 mb-6" data-id="element-173">
                <XCircle className="w-6 h-6 text-brand-red shrink-0" data-id="element-174" />
                <h3 className="text-sm font-bold uppercase tracking-wider text-brand-red leading-tight" data-id="element-175">
                  Antes
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-176">
                {before.map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text" data-id="element-177">
                    <XCircle className="w-5 h-5 text-brand-red/60 shrink-0 mt-0.5" data-id="element-178" />
                    <span className="text-sm md:text-base font-medium leading-snug" data-id="element-179">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* CON MÚSICA LISTA */}
            <div className="bg-[#fdfaf6] p-6 md:p-8 sm:border-l border-t sm:border-t-0 border-brand-creamDark" data-id="element-180">
              <div className="flex items-center gap-2 mb-6" data-id="element-181">
                <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0" data-id="element-182" />
                <h3 className="text-sm font-bold uppercase tracking-wider text-brand-gold leading-tight" data-id="element-183">
                  Con Música Lista
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-184">
                {after.map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text" data-id="element-185">
                    <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-186" />
                    <span className="text-sm md:text-base font-semibold leading-snug" data-id="element-187">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}